module.exports = __webpack_public_path__ + "static/media/menu.019c8402.svg";